import React from "react";
import { Info, MapPin, ClipboardCheck, CalendarCheck } from "lucide-react";

const Callouts = ({ items }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="service-callouts">
    {items.map((c) => (
      <div key={c.title} className="bg-white border border-black/8 rounded-md p-6">
        <Info className="h-4 w-4 text-accent mb-4" />
        <h3 className="font-display font-semibold text-[1.05rem] tracking-tight mb-2">{c.title}</h3>
        <p className="text-[13px] text-muted-foreground leading-relaxed">{c.body}</p>
      </div>
    ))}
  </div>
);

const Checklist = ({ items, onBook }) => (
  <div className="bg-paper-warm border border-black/8 rounded-md p-8" data-testid="service-checklist">
    <ClipboardCheck className="h-5 w-5 text-brand mb-4" />
    <h3 className="font-display font-semibold text-[1.4rem] tracking-tight mb-2">Before your engineer arrives</h3>
    <p className="text-[13px] text-muted-foreground mb-6">Have these ready and we can usually fix it on the first visit.</p>
    <ol className="space-y-3 list-decimal pl-5 text-[14px] text-ink/80 leading-relaxed">
      {items.map((i) => <li key={i}>{i}</li>)}
    </ol>
    <button type="button" onClick={onBook} data-testid="service-checklist-book"
      className="mt-8 inline-flex items-center gap-2 px-5 py-3 bg-brand text-white font-semibold text-[14px] rounded-sm hover:bg-accent transition-colors">
      Book a free site survey <CalendarCheck className="h-4 w-4" />
    </button>
  </div>
);

const Areas = ({ areas }) => (
  <div className="bg-ink text-white rounded-md p-8" data-testid="service-areas">
    <MapPin className="h-5 w-5 text-accent mb-4" />
    <h3 className="font-display font-semibold text-[1.4rem] tracking-tight mb-6 text-white">Where we cover</h3>
    <div className="space-y-5">
      {areas.map((a) => (
        <div key={a.region}>
          <div className="font-mono text-[10px] tracking-overline uppercase text-white/50 mb-1">{a.region}</div>
          <div className="text-[14px] text-white/85 leading-relaxed">{a.places}</div>
        </div>
      ))}
    </div>
  </div>
);

const ServiceExtras = ({ service, onBook }) => {
  if (!service.callouts && !service.checklist && !service.serviceAreas) return null;
  return (
    <section className="pb-24 max-w-editorial mx-auto px-6 md:px-10 lg:px-12 space-y-6">
      {service.callouts && (
        <>
          <div className="font-mono text-[11px] tracking-overline uppercase text-muted">[ Good to know ]</div>
          <Callouts items={service.callouts} />
        </>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {service.checklist && <div className="lg:col-span-7"><Checklist items={service.checklist} onBook={onBook} /></div>}
        {service.serviceAreas && <div className="lg:col-span-5"><Areas areas={service.serviceAreas} /></div>}
      </div>
    </section>
  );
};

export default ServiceExtras;
